<template>
  <el-dialog 
    :title="$t('editBusinessTableHis.editBusinessTrack')"
    :visible.sync="dialogVisible"
    width="50%"
  >
    <el-form :model="editBusinessTableHisInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('editBusinessTableHis.businessType')" prop="businessTypeCd">
        <el-input 
          v-model="editBusinessTableHisInfo.businessTypeCd" 
          :placeholder="$t('editBusinessTableHis.requiredBusinessType')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editBusinessTableHis.action')" prop="action">
        <el-select 
          v-model="editBusinessTableHisInfo.action" 
          :placeholder="$t('editBusinessTableHis.requiredAction')"
          style="width:100%"
        >
          <el-option 
            :label="$t('editBusinessTableHis.pleaseSelect')" 
            value="" 
            disabled
          ></el-option>
          <el-option 
            label="ADD" 
            value="ADD"
          ></el-option>
          <el-option 
            label="MOD" 
            value="MOD"
          ></el-option>
          <el-option 
            label="DEL" 
            value="DEL"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editBusinessTableHis.tableName')" prop="actionObj">
        <el-input 
          v-model="editBusinessTableHisInfo.actionObj" 
          :placeholder="$t('editBusinessTableHis.requiredTableName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editBusinessTableHis.trackTableName')" prop="actionObjHis">
        <el-input 
          v-model="editBusinessTableHisInfo.actionObjHis" 
          :placeholder="$t('editBusinessTableHis.requiredTrackTableName')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editBusinessTableHis.remark')">
        <el-input 
          v-model="editBusinessTableHisInfo.remark" 
          :placeholder="$t('editBusinessTableHis.optionalRemark')"
          type="textarea"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editBusinessTableHis">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateBusinessTableHis } from '@/api/dev/businessTableHisApi'

export default {
  name: 'EditBusinessTableHis',
  data() {
    return {
      dialogVisible: false,
      editBusinessTableHisInfo: {
        hisId: '',
        businessTypeCd: '',
        action: '',
        actionObj: '',
        actionObjHis: '',
        remark: ''
      },
      rules: {
        hisId: [
          { required: true, message: this.$t('editBusinessTableHis.requiredTrackId'), trigger: 'blur' }
        ],
        businessTypeCd: [
          { required: true, message: this.$t('editBusinessTableHis.requiredBusinessType'), trigger: 'blur' },
          { max: 30, message: this.$t('editBusinessTableHis.max30Chars'), trigger: 'blur' }
        ],
        action: [
          { required: true, message: this.$t('editBusinessTableHis.requiredAction'), trigger: 'change' }
        ],
        actionObj: [
          { required: true, message: this.$t('editBusinessTableHis.requiredTableName'), trigger: 'blur' },
          { max: 64, message: this.$t('editBusinessTableHis.max64Chars'), trigger: 'blur' }
        ],
        actionObjHis: [
          { required: true, message: this.$t('editBusinessTableHis.requiredTrackTableName'), trigger: 'blur' },
          { max: 64, message: this.$t('editBusinessTableHis.max64Chars'), trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: this.$t('editBusinessTableHis.max200Chars'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editBusinessTableHisInfo = { ...row }
    },
    editBusinessTableHis() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          await updateBusinessTableHis(this.editBusinessTableHisInfo)
          this.$message.success(this.$t('editBusinessTableHis.editSuccess'))
          this.dialogVisible = false
          this.$emit('success')
        } catch (error) {
          console.error('修改业务轨迹失败:', error)
        }
      })
    }
  }
}
</script>